import api from './axios';

export const getDashboardApi        = ()           => api.get('/admin/dashboard');
export const getSalesReportApi      = (params)     => api.get('/admin/reports/sales', { params });
export const getAnalyticsApi        = ()           => api.get('/admin/analytics');

export const getAdminOrdersApi      = (params)     => api.get('/admin/orders', { params });
export const getAdminOrderDetailApi = (id)         => api.get(`/admin/orders/${id}`);
export const updateOrderStatusApi   = (id, data)   => api.put(`/admin/orders/${id}/status`, data);

export const getCustomersApi        = (params)     => api.get('/admin/customers', { params });
export const toggleCustomerApi      = (id)         => api.patch(`/admin/customers/${id}/toggle`);

export const getAllCouponsApi        = ()           => api.get('/admin/coupons');
export const createCouponApi        = (data)       => api.post('/admin/coupons', data);
export const updateCouponApi        = (id, data)   => api.put(`/admin/coupons/${id}`, data);
export const deleteCouponApi        = (id)         => api.delete(`/admin/coupons/${id}`);
export const toggleCouponApi        = (id)         => api.patch(`/admin/coupons/${id}/toggle`);

export const getInventoryApi        = ()           => api.get('/admin/inventory');
export const bulkUpdateInventoryApi = (updates)    => api.patch('/admin/inventory/bulk', { updates });

export const getSettingsApi         = ()           => api.get('/admin/settings');
export const updateSettingsApi      = (data)       => api.put('/admin/settings', data);

export const getBannersApi          = ()           => api.get('/admin/banners');
export const createBannerApi        = (data)       => api.post('/admin/banners', data);
export const updateBannerApi        = (id, data)   => api.put(`/admin/banners/${id}`, data);
export const deleteBannerApi        = (id)         => api.delete(`/admin/banners/${id}`);
export const toggleBannerApi        = (id)         => api.patch(`/admin/banners/${id}/toggle`);
export const uploadBannerImageApi   = (form)       => api.post('/admin/banners/upload-image', form, { headers: { 'Content-Type': undefined } });

export const getAdminUsersApi       = ()           => api.get('/admin/admin-users');
export const createAdminUserApi     = (data)       => api.post('/admin/admin-users', data);
export const toggleAdminUserApi     = (id)         => api.patch(`/admin/admin-users/${id}/toggle`);

export const downloadReportApi      = (type)       => api.get(`/admin/reports/${type}`, { responseType: 'blob' });
